/* eslint-disable jsx-a11y/media-has-caption */
import React from 'react';

import PropTypes from 'prop-types';

import PlayLogo from '@/assets/icons/si-glyph-circle-triangle-right.svg';

import './VideoPlayer.less';

const VideoPlayer = React.forwardRef(
  ({hidePlayButton, actionPlayButton, id, className, controls, autoPlay, src, videoType, onEnded, poster}, ref) => (
    <div className="center">
      <button
        type="button"
        hidden={hidePlayButton}
        className="play-button"
        onClick={() => {
          actionPlayButton();
        }}
      >
        <img
          alt={PlayLogo}
          src={PlayLogo}
          height={100}
          width={100}
        />
      </button>
      <video
        id={id}
        className={className}
        controls={controls}
        autoPlay={autoPlay} // not working
        // loop
        ref={ref}
        src={src}
        type={videoType}
        onEnded={onEnded}
        poster={poster}
      >
        Your browser does not support the video tag.
      </video>
    </div>
  ),
);

VideoPlayer.propTypes = {
  hidePlayButton: PropTypes.bool,
  actionPlayButton: PropTypes.func,
  id: PropTypes.string,
  className: PropTypes.string,
  controls: PropTypes.bool,
  autoPlay: PropTypes.bool,
  src: PropTypes.string,
  videoType: PropTypes.any,
  onEnded: PropTypes.func,
  poster: PropTypes.string,
};

VideoPlayer.defaultProps = {
  id: '',
  hidePlayButton: false,
  actionPlayButton: () => {},
  className: '',
  controls: false,
  autoPlay: false,
  src: '',
  videoType: null,
  onEnded: () => {},
  poster: '',
};

export default VideoPlayer;

// VideoPlayer.propTypes = {
//    VideoPlayer : PropTypes.array.isRequired
// }
